import { guid } from '../../core/libs/ui-helper';

class MagnifierController {

  constructor() {
    'ngInject';
    this.isVisible = false;
    this.componentId = guid();
    this.magnifierImageId = `magnifier-image-${this.componentId}`;
    this.magnifierResultId = `magnifier-result-${this.componentId}`;
    this.magnifierLensId = `magnifier-lens-${this.componentId}`;
    this.magnifierBG = `magnifier-bg-${this.componentId}`
  }

  $postLink() {
    // setTimeout(() => {this.imageZoom(this.magnifierImageId, this.magnifierResultId, this.magnifierLensId)}, 1000);
    setTimeout(() => {this.magnify(this.magnifierImageId, 3.4)}, 1000);
  }

  toggleMagnifier($event, value) {
    this.isVisible = value;
  }

  handleMouseMove($event) {
    const img = document.getElementById(this.magnifierImageId);

    const minPosition = $(img).offset().top + (img.clientHeight * this.unShowPercent);

    if (minPosition <= $event.pageY) {
      this.isVisible = true;
    } else {
      this.isVisible = false;
    }

  }

  // imageZoom(imgID, resultID, lensId) {
  //   let img, lens, result, cx, cy;
  //   img = document.getElementById(imgID);
  //   result = document.getElementById(resultID);
  //   lens = document.getElementById(lensId);
  //   /* Calculate the ratio between result DIV and lens: */
  //   cx = result.offsetWidth / lens.offsetWidth;
  //   cy = result.offsetHeight / lens.offsetHeight;
  //   /* Set background properties for the result DIV */
  //   result.style.backgroundImage = "url('" + img.src + "')";
  //   result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
  //   /* Execute a function when someone moves the cursor over the image, or the lens: */
  //   lens.addEventListener("mousemove", moveLens);
  //   img.addEventListener("mousemove", moveLens);
  //   /* And also for touch screens: */
  //   lens.addEventListener("touchmove", moveLens);
  //   img.addEventListener("touchmove", moveLens);
  //   function moveLens(e) {
  //     let pos, x, y;
  //     /* Prevent any other actions that may occur when moving over the image */
  //     e.preventDefault();
  //     /* Get the cursor's x and y positions: */
  //     pos = getCursorPos(e);
  //     /* Calculate the position of the lens: */
  //     x = pos.x - (lens.offsetWidth / 2);
  //     y = pos.y - (lens.offsetHeight / 2);
  //     /* Prevent the lens from being positioned outside the image: */
  //     if (x > img.width - lens.offsetWidth) {x = img.width - lens.offsetWidth;}
  //     if (x < 0) {x = 0;}
  //     if (y > img.height - lens.offsetHeight) {y = img.height - lens.offsetHeight;}
  //     if (y < 0) {y = 0;}
  //     /* Set the position of the lens: */
  //     lens.style.left = x + "px";
  //     lens.style.top = y + "px";
  //     /* Display what the lens "sees": */
  //     result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
  //   }
  //   function getCursorPos(e) {
  //     let a, x = 0, y = 0;
  //     e = e || window.event;
  //     /* Get the x and y positions of the image: */
  //     a = img.getBoundingClientRect();
  //     /* Calculate the cursor's x and y coordinates, relative to the image: */
  //     x = e.pageX - a.left;
  //     y = e.pageY - a.top;
  //     /* Consider any page scrolling: */
  //     x = x - window.pageXOffset;
  //     y = y - window.pageYOffset;
  //     return {x : x, y : y};
  //   }
  // }

  magnify(imgID, zoom) {
    var img, glass, w, h, bw, magnifier;
    img = document.getElementById(imgID);
    glass = document.getElementById(this.magnifierLensId);
    magnifier = document.getElementById(this.magnifierBG);

    /* Create magnifier glass: */
    // glass = document.createElement("DIV");
    // glass.setAttribute("class", "img-magnifier-glass");

    /* Insert magnifier glass: */
    img.parentElement.insertBefore(glass, img);

    /* Set background properties for the magnifier glass: */
    glass.style.backgroundImage = "url('" + img.src + "')";
    glass.style.backgroundRepeat = "no-repeat";
    glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";
    bw = 3;
    w = glass.offsetWidth / 2;
    h = glass.offsetHeight / 2;

    /* Execute a function when someone moves the magnifier glass over the image: */
    glass.addEventListener("mousemove", moveMagnifier);
    img.addEventListener("mousemove", moveMagnifier);
    magnifier.addEventListener("mousemove", moveMagnifier);

    /*and also for touch screens:*/
    glass.addEventListener("touchmove", moveMagnifier);
    img.addEventListener("touchmove", moveMagnifier);
    magnifier.addEventListener("touchmove", moveMagnifier);

    function moveMagnifier(e) {
      var pos, x, y;
      /* Prevent any other actions that may occur when moving over the image */
      e.preventDefault();
      /* Get the cursor's x and y positions: */
      pos = getCursorPos(e);
      x = pos.x;
      y = pos.y;
      /* Prevent the magnifier glass from being positioned outside the image: */
      if (x > img.width - (w / zoom)) {x = img.width - (w / zoom);}
      if (x < w / zoom) {x = w / zoom;}
      if (y > img.height - (h / zoom)) {y = img.height - (h / zoom);}
      if (y < h / zoom) {y = h / zoom;}
      /* Set the position of the magnifier glass: */
      glass.style.left = (x - w) + "px";
      glass.style.top = (y - h) + "px";
      /* Set the position of the magnifier background: */
      magnifier.style.left = (x - w) + 40 + "px";
      magnifier.style.top = (y - h) + 80 + "px";
      /* Display what the magnifier glass "sees": */
      glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
    }

    function getCursorPos(e) {
      var a, x = 0, y = 0;
      e = e || window.event;
      /* Get the x and y positions of the image: */
      a = img.getBoundingClientRect();
      /* Calculate the cursor's x and y coordinates, relative to the image: */
      x = e.pageX - a.left;
      y = e.pageY - a.top;
      /* Consider any page scrolling: */
      x = x - window.pageXOffset;
      y = y - window.pageYOffset;
      return {x : x, y : y};
    }
  }

}

export default MagnifierController;



// WEBPACK FOOTER //
// ./client/app/components/magnifier/magnifier.controller.js